<app-loading *ngIf="isLoading$ | async" title="step groups"></app-loading>

<!-- Add a new plan  -->
<ng-container *ngIf="existingPlanToNew && updatecheckSuccess && createCheck">
    <div class="loading-container" *ngIf="deviceLoader">
        <img
                src="assets/images/loading.gif"
                alt="loading..."
                class="loading-icon"
        />
    </div>
    <div class="devices-wrapper">
        <div class="device-nav">
            <div class="device-card-heading">
                <p i18n="@@devicesAttach" class="text-secondary">
                    Select devices to attach to a plan
                </p>
            </div>
        </div>

        <div class="devices-outer">
            <div class="devices-card-wrapper">
                <div
                        class="device-card"
                        *ngFor="let device of devicesforDisplay"
                        [class.selected]="isSelected(device)"
                        (click)="selectDevice(device)"
                >
          <span class="device image-outer">
            <img
                    class="device-image"
                    [src]="
                getImageUrl(
                  device?.device_model_id
                    ? device?.device_model_id
                    : device?.model
                )
              "
                    alt=" "
            />
          </span>
                    <div class="card-text">
                        <p>{{ device?.name }}</p>
                        <p class="small">{{ device?.model }}</p>
                        <span class="small">{{ device?.id }}</span>
                    </div>
                    <!-- <div>
                                    <input id="{{device?.id}}" type="checkbox" >
                                </div> -->
                    <div *ngIf="!selectedDevices.includes(device)">
            <span>
              <img src="assets/images/plusdevice.svg" alt=" "/>
            </span>
                    </div>
                    <div *ngIf="selectedDevices.includes(device)">
            <span class="check-icon-span">
              <img src="assets/images/selectdevice.svg" alt=" "/>
            </span>
                    </div>
                </div>
            </div>

            <ng-container *ngIf="!devicesforDisplay?.length && !deviceLoader">
                <app-no-compatible-devices></app-no-compatible-devices>
            </ng-container>

            <ng-container *ngIf="incompatibleDevices?.length > 0">
                <div>
                    <div class="device-card-heading">
                        <h3 i18n="@@inCompatible">Unavailable devices</h3>
                        <p class="py-2 text-secondary" i18n="@@inCompatibleLongDescription">
                            These devices can not be added to the plan because they are either
                            incompatible, used with a different plan, or you are not the
                            device owner:
                        </p>
                    </div>

                    <div
                            *ngIf="incompatibleDevices?.length > 0"
                            class="devices-card-wrapper disabled"
                    >
                        <div
                                class="device-card"
                                *ngFor="let device of incompatibleDevices"
                                disabled
                        >
              <span class="device image-outer">
                <img
                        class="device-image"
                        [src]="
                    getImageUrl(
                      device?.device_model_id
                        ? device?.device_model_id
                        : device?.model
                    )
                  "
                        alt="{{ device?.model }}"
                />
              </span>
                            <div class="card-text" disabled>
                                <p>{{ device?.name }}</p>
                                <p class="small">
                                    {{
                                        device?.device_model_id
                                            ? device?.device_model_id
                                            : device?.model
                                    }}
                                </p>
                                <span class="small">{{ device?.id }}</span>

                                <!-- Add this block to show the note when the device is not owned by the user -->
                                <p *ngIf="!device?.owner" class="not-owned-note">
                                    shared device
                                </p>
                                <!-- <p >Incompatible device</p> -->
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="footer">
            <ng-container *ngIf="extistingDevices">
                <div class="device-btn-wrapper jjjjjjjjjj">
                    <button
                            *ngIf="shopCampatible || extistingDevices"
                            [disabled]="!selectedDevices?.length"
                            (click)="onClickForDetails()"
                            class="btn"
                            i18n="@@selectAndContinue"
                    >
                        Select devices and continue
                    </button>
                    <span>
            <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19.212"
                    height="16.842"
                    viewBox="0 0 19.212 16.842"
            >
              <g
                      id="Group_11881"
                      data-name="Group 11881"
                      transform="translate(-443.343 -907.672)"
              >
                <line
                        id="Line_743"
                        data-name="Line 743"
                        x1="17.012"
                        transform="translate(444.443 916.093)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2.2"
                />
                <path
                        id="Path_11696"
                        data-name="Path 11696"
                        d="M13.731,0,6.866,6.866,0,0"
                        transform="translate(454.589 922.958) rotate(-90)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2.2"
                />
              </g>
            </svg>
          </span>
                </div>
            </ng-container>
            <ng-container *ngIf="shopCampatible && !extistingDevices">
                <div class="device-btn-wrapper dummy">
                    <button
                            *ngIf="shopCampatible || extistingDevices"
                            [disabled]="!selectedDevices?.length"
                            (click)="onClickForDetails()"
                            class="btn"
                            i18n="@@selectAndContinue"
                    >
                        Select devices and continue
                    </button>
                    <span>
            <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19.212"
                    height="16.842"
                    viewBox="0 0 19.212 16.842"
            >
              <g
                      id="Group_11881"
                      data-name="Group 11881"
                      transform="translate(-443.343 -907.672)"
              >
                <line
                        id="Line_743"
                        data-name="Line 743"
                        x1="17.012"
                        transform="translate(444.443 916.093)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2.2"
                />
                <path
                        id="Path_11696"
                        data-name="Path 11696"
                        d="M13.731,0,6.866,6.866,0,0"
                        transform="translate(454.589 922.958) rotate(-90)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2.2"
                />
              </g>
            </svg>
          </span>
                </div>
            </ng-container>
        </div>
    </div>
</ng-container>

<!-- Modify plan page  -->
<ng-container
        *ngIf="
    ((!existingPlanToNew && devicesforDisplay?.length) ||
      incompatibleDevices) &&
    updatecheckSuccess &&
    !createCheck
  "
>
    <div class="loading-container" *ngIf="deviceLoader">
        <img
                src="assets/images/loading.gif"
                alt="loading..."
                class="loading-icon"
        />
    </div>
    <div class="devices-wrapper" *ngIf="!deviceLoader">
        <div class="mobile-screen-btn-wrapper">
      <span (click)="goBack(false)"
      ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="15.28"
              height="13.669"
              viewBox="0 0 15.28 13.669"
      >
          <g
                  id="Group_11958"
                  data-name="Group 11958"
                  transform="translate(1.1 1.556)"
          >
            <line
                    id="Line_743"
                    data-name="Line 743"
                    x2="13.08"
                    transform="translate(0 5.279)"
                    fill="none"
                    stroke="#53555b"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2.2"
            />
            <path
                    id="Path_11696"
                    data-name="Path 11696"
                    d="M10.558,5.279,5.279,0,0,5.279"
                    transform="translate(0 10.558) rotate(-90)"
                    fill="none"
                    stroke="#53555b"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2.2"
            />
          </g>
        </svg>
      </span>
            <div *ngIf="showAutoRenewButton()" class="btn-mobile-screen">
                <button
                        i18n="@@cancelSubscription"
                        *ngIf="selectExistingDevice?.length && extistingDevices"
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop"
                        (click)="disableAutoRenew()"
                        [disabled]="
            this.activePlan?.subscriptionDetails?.next_billing_date ==
            this.activePlan?.subscriptionDetails?.unsubscription_at
          "
                >
                    Disable auto renewal
                </button>
            </div>
        </div>
        <div class="device-nav">
            <div class="device-card-heading">
                <h3 i18n>{{ planName }}</h3>
                <p i18n="@@devicesAttach">Select devices to attach to your plan</p>
            </div>
            <div class="device-btn">
                <button
                        *ngIf="showAutoRenewButton()"
                        i18n="@@cancelSubscription"
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop"
                        (click)="disableAutoRenew()"
                        [disabled]="
            this.activePlan?.subscriptionDetails?.next_billing_date ==
            this.activePlan?.subscriptionDetails?.unsubscription_at
          "
                >
                    Disable auto renewal
                </button>
            </div>
        </div>
        <div class="devices-outer">
            <div class="devices-card-wrapper">
                <div
                        class="device-card"
                        *ngFor="let device of devicesforDisplay"
                        [class.selected]="isExistingSelected(device)"
                        (click)="selectExistingDevice(device)"
                >
          <span class="device image-outer">
            <img
                    class="device-image"
                    [src]="
                getImageUrl(
                  device?.device_model_id
                    ? device?.device_model_id
                    : device?.model
                )
              "
                    alt=" "
            />
          </span>
                    <div class="card-text">
                        <p>{{ device?.name }}</p>
                        <p class="small">
                            {{
                                device?.device_model_id
                                    ? device?.device_model_id
                                    : device?.model
                            }}
                        </p>
                        <span class="small">{{ device?.id }}</span>
                    </div>

                    <div *ngIf="!isExistingSelected(device)">
            <span>
              <img src="assets/images/plusdevice.svg" alt=" "/>
            </span>
                    </div>
                    <div *ngIf="isExistingSelected(device)">
            <span class="check-icon-span">
              <img src="assets/images/selectdevice.svg" alt=" "/>
            </span>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="!devicesforDisplay?.length">
                <app-no-compatible-devices></app-no-compatible-devices>
            </ng-container>
            <ng-container *ngIf="incompatibleDevices?.length > 0">
                <div>
                    <div class="device-card-heading">
                        <h3 i18n="@@inCompatible">Unavailable devices</h3>
                        <p class="py-2 text-secondary" i18n="@@inCompatibleLongDescription">
                            These devices can not be added to the plan because they are either
                            incompatible or used with a different plan:
                        </p>
                    </div>
                    <div class="devices-card-wrapper disabled">
                        <div
                                class="device-card"
                                *ngFor="let device of incompatibleDevices"
                                disabled
                        >
              <span class="device image-outer">
                <img
                        class="device-image"
                        [src]="
                    getImageUrl(
                      device?.device_model_id
                        ? device?.device_model_id
                        : device?.model
                    )
                  "
                        alt="{{ device?.model }}"
                />
              </span>
                            <div class="card-text">
                                <p>{{ device?.name }}</p>
                                <p>{{ device?.model }}</p>
                                <span class="small">{{ device?.id }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <div
                [ngClass]="
        !shopCampatible || existingPlanDevicesForMobile
          ? 'mobile-footer'
          : 'footer'
      "
        >
            <button
                    class="btn-outline"
                    i18n="@@cancelChanges"
                    (click)="cancelSubscriptionDevices()"
            >
                Cancel
            </button>
            <button class="btn" i18n="@@applyCahnges" (click)="onClickCheckout()">
                Apply changes
            </button>
        </div>

    </div>
</ng-container>

<!-- this is for Plan  have but no devices
<ng-container *ngIf="!(isLoading$ | async)">
    <ng-container
            *ngIf="!existingPlanToNew && !devicesforDisplay.length && updatecheckSuccess"
    >

        <app-no-compatible-devices
                *ngIf="!incompatibleDevices.length && !createCheck"
                (changeonBackCLick)="clickonNoCompatibleBack($event)"
                [activePlan]="activePlan"
        ></app-no-compatible-devices>
    </ng-container>
</ng-container>
-->

<!-- this is for Success Plan  -->
<ng-container>
    <ng-container *ngIf="!updatecheckSuccess">
        <div class="loading-container" *ngIf="deviceLoader">
            <img
                    src="assets/images/loading.gif"
                    alt="loading..."
                    class="loading-icon"
            />
        </div>
        <app-success-devices
                *ngIf="!deviceLoader"
                (receivedModification)="modifyPlan($event)"
                [successDeviceList]="successDeviceList"
                [planName]="planName"
        ></app-success-devices>
    </ng-container>
</ng-container>

<div
        class="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
>
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
        <span class="icon">
          <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="67.5"
                  height="67.5"
                  viewBox="0 0 67.5 67.5"
          >
            <g
                    id="Group_11925"
                    data-name="Group 11925"
                    transform="translate(-1547.686 -378.687)"
            >
              <line
                      id="Line_734"
                      data-name="Line 734"
                      y2="20.71"
                      transform="translate(1581.437 395.177)"
                      fill="none"
                      stroke="#f26666"
                      stroke-linecap="round"
                      stroke-width="5.5"
              />
              <line
                      id="Line_735"
                      data-name="Line 735"
                      y2="1"
                      transform="translate(1581.437 426.936)"
                      fill="none"
                      stroke="#f26666"
                      stroke-linecap="round"
                      stroke-width="5.5"
              />
              <circle
                      id="Ellipse_846"
                      data-name="Ellipse 846"
                      cx="31"
                      cy="31"
                      r="31"
                      transform="translate(1550.436 381.437)"
                      fill="none"
                      stroke="#f26666"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="5.5"
              />
            </g>
          </svg>
        </span>
                <p class="desc-first" i18n="@@subscriptiontitle">
                    Are you sure you would like to disable the auto renewal of your Lorex
                    Cloud Storage subscription?
                </p>
                <p class="desc-last" i18n="@@subscriptionDescription">
                    Your subscription will end at the end of the current billing cycle. At
                    that time, you will no longer have access to the service for your
                    cameras.
                </p>
            </div>
            <div class="modal-footer">
                <button
                        type="button"
                        class="modal-btn"
                        #closebutton
                        data-bs-dismiss="modal"
                        i18n="@@disabledButton"
                        (click)="onClickDisableAutoRenew()"
                >
                    Disable auto renewal
                </button>
                <button
                        type="button"
                        class="btn-outline"
                        i18n="@@keepChnages"
                        data-bs-dismiss="modal"
                >
                    Keep my subscription
                </button>
            </div>
        </div>
    </div>
</div>
